module.exports = __webpack_public_path__ + "static/example-30a87786d17dcc0820f02709d00c60bf.png";